import { Card, Title } from '@mantine/core';
import { t } from 'i18next';

import { Header, Page, ForecastTable, LabeledText, Number, ScenarioChart } from 'components';
import { Co2Footprint, TargetSettings } from 'models';

type ComparisonProps = {
    targetSettings: TargetSettings
    co2Footprint: Co2Footprint
    onClose: () => void;
}

export const Comparison = ({ targetSettings, co2Footprint, onClose }: ComparisonProps) => {
    return (
        <div className="page">
            <Header title={t('comparison')} onClose={() => onClose()} />
            <Page>
                <div className="flex flex-col gap-6">
                    <div className="flex flex-row gap-6 w-full">
                        <Card className="flex flex-col gap-lg p-6 min-h-44 w-full">
                            <Title order={4}>{t('targetSettings')}</Title>
                            <div className="flex flex-row gap-xl w-full">
                                <LabeledText label={t('targetTime')}>
                                    <Number unit="h">
                                        {targetSettings.targetTime}
                                    </Number>
                                </LabeledText>
                                <LabeledText label={t('structure')}>
                                    {targetSettings.structure?.name}
                                </LabeledText>
                                <LabeledText label={t('targetValue')}>
                                    <Number unit="MPa">
                                        {targetSettings.targetValue}
                                    </Number>
                                </LabeledText>
                            </div>
                        </Card>
                        <Card className="flex flex-col gap-lg p-6 min-h-44 w-full">
                            <Title order={4}>{t('co2Footprint')}</Title>
                            <div className="flex flex-row gap-xl w-full">
                                <LabeledText label={t('co2Electricity')}>
                                    <Number unit="g&nbsp;CO₂/kWh">
                                        {co2Footprint.co2Electricity}
                                    </Number>
                                </LabeledText>
                                <LabeledText label={t('concreteVolume')}>
                                    <Number unit="m³">
                                        {co2Footprint.concreteVolume}
                                    </Number>
                                </LabeledText>
                                <LabeledText label={t('formworkSurface')}>
                                    <Number unit="m²">
                                        {co2Footprint.formworkSurface}
                                    </Number>
                                </LabeledText>
                                <LabeledText label={t('electricityCosts')}>
                                    <Number decimalScale={2} fixedDecimalScale={true} unit="€/kWh">
                                        {co2Footprint.electricityCosts}
                                    </Number>
                                </LabeledText>
                            </div>
                        </Card>
                    </div>
                    <ForecastTable />
                    <div className="flex flex-row gap-6 w-full mb-6">
                        <Card className="flex flex-col gap-lg p-6 w-full min-w-0">
                            <Title order={4}>{`${t('totalCo2Footprint')}`}</Title>
                            <ScenarioChart type="footprint" />
                        </Card>
                        <Card className="flex flex-col gap-lg p-6 w-full min-w-0">
                            <Title order={4}>{`${t('totalCosts')}`}</Title>
                            <ScenarioChart type="costs" />
                        </Card>
                    </div>
                </div>
            </Page>
        </div>
    );
};